import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import get from 'lodash.get';
export default (function (palette, color) {
  if (color === 'divider') {
    return palette.divider;
  }

  if (color.includes('.') && !color.includes('rgb') && !color.includes('hsl')) {
    return get(palette, color);
  }

  return color;
});